import { API_PREFIX, API_VERSION, Command, HttpVerbType } from "../Command";
import { ApiGenericResponse } from "../ApiGenericResponse";

const ENDPOINT = "/device/tree/move";

export class MoveFolderCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "post";
    params: MoveFolderReqData;

    constructor(params: MoveFolderReqData) {
        super();
        this.params = params;
    }

    public async execute(): Promise<ApiGenericResponse> {
        var res = await this.executeCommand(this.params);
        return new ApiGenericResponse(res);
    }
}

export class MoveFolderReqData {
    folderId: number;
    newParentFolderId: number;

    constructor(folderId: number, newParentFolderId: number) {
        this.folderId = folderId;
        this.newParentFolderId = newParentFolderId;
    }
}
